import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BRAND } from '../data/constants';

const FEATURES = [
  { icon: '📤', text: 'Dépôt centralisé' },
  { icon: '🛵', text: 'Gestion des livreurs' },
  { icon: '📍', text: 'Suivi en temps réel' },
  { icon: '💸', text: 'Wave & Orange Money' },
];

export default function HomePage() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight:       '100vh',
      background:      'linear-gradient(135deg, #1e1b4b 0%, #312e81 45%, #4c1d95 100%)',
      display:         'flex',
      flexDirection:   'column',
      alignItems:      'center',
      justifyContent:  'center',
      padding:         '40px 20px',
      position:        'relative',
      overflow:        'hidden',
      fontFamily:      "'DM Sans', sans-serif",
    }}>
      {/* Cercles déco */}
      <Orb top="-120px" right="-120px" size={500} opacity={0.12} />
      <Orb bottom="-80px" left="-80px"  size={420} opacity={0.09} />

      <div style={{ textAlign: 'center', maxWidth: 620, position: 'relative', zIndex: 1 }}>
        {/* Logo */}
        <div style={{ fontSize: 80, marginBottom: 24, display: 'inline-block', animation: 'float 3s ease-in-out infinite' }}>
          📦
        </div>

        {/* Titre */}
        <h1 style={{
          fontSize:      'clamp(36px, 7vw, 60px)',
          fontWeight:    800,
          color:         'white',
          margin:        '0 0 16px',
          letterSpacing: -2,
          lineHeight:    1.1,
        }}>
          Zaki<span style={{ color: '#a5b4fc' }}>Express</span>
        </h1>
        <p style={{
          fontSize:    18,
          color:       'rgba(255,255,255,0.72)',
          marginBottom: 48,
          lineHeight:  1.7,
        }}>
          Plateforme de gestion centralisée des livraisons à Dakar.<br />
          Suivi temps réel · Wave & Orange Money · Gestion livreurs.
        </p>

        {/* Feature grid */}
        <div style={{
          display:             'grid',
          gridTemplateColumns: '1fr 1fr',
          gap:                 14,
          maxWidth:            480,
          margin:              '0 auto 48px',
        }}>
          {FEATURES.map(f => (
            <div key={f.text} style={{
              background:  'rgba(255,255,255,0.08)',
              borderRadius: 14,
              padding:     '16px 20px',
              border:      '1px solid rgba(255,255,255,0.12)',
              display:     'flex',
              alignItems:  'center',
              gap:         12,
              transition:  'background 0.2s',
            }}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.14)'}
              onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.08)'}
            >
              <span style={{ fontSize: 26 }}>{f.icon}</span>
              <span style={{ color: 'rgba(255,255,255,0.9)', fontWeight: 600, fontSize: 14 }}>{f.text}</span>
            </div>
          ))}
        </div>

        {/* CTA buttons */}
        <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
          <CTA
            primary
            onClick={() => navigate('/depot')}
          >
            📥 Nouveau dépôt
          </CTA>
          <CTA onClick={() => navigate('/mes-colis')}>
            📦 Mes colis
          </CTA>
          <CTA onClick={() => navigate('/suivi')}>
            🔍 Suivre un colis
          </CTA>
        </div>
      </div>
    </div>
  );
}

function CTA({ children, onClick, primary }) {
  return (
    <button onClick={onClick} style={{
      padding:      '16px 40px',
      background:   primary ? 'white' : 'transparent',
      color:        primary ? BRAND.primary : 'white',
      border:       primary ? 'none' : '2px solid rgba(255,255,255,0.4)',
      borderRadius: 14,
      fontWeight:   800,
      fontSize:     16,
      cursor:       'pointer',
      display:      'flex',
      alignItems:   'center',
      gap:          10,
      transition:   'all 0.2s',
      fontFamily:   'inherit',
      boxShadow:    primary ? '0 8px 32px rgba(0,0,0,0.3)' : 'none',
    }}
      onMouseEnter={e => {
        e.currentTarget.style.transform = 'translateY(-3px)';
        e.currentTarget.style.boxShadow = primary
          ? '0 12px 40px rgba(0,0,0,0.35)'
          : '0 4px 16px rgba(0,0,0,0.2)';
        if (!primary) e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = 'none';
        e.currentTarget.style.boxShadow = primary ? '0 8px 32px rgba(0,0,0,0.3)' : 'none';
        if (!primary) e.currentTarget.style.background = 'transparent';
      }}
    >
      {children}
    </button>
  );
}

function Orb({ top, bottom, left, right, size, opacity }) {
  return (
    <div style={{
      position:     'absolute',
      top, bottom, left, right,
      width:        size,
      height:       size,
      borderRadius: '50%',
      background:   `rgba(99,102,241,${opacity})`,
      pointerEvents:'none',
    }} />
  );
}
